import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { isArray } from 'util';
import { environment } from '../../../../environments/environment';
import { CamProgramArticleFormInterface } from '../../../dashboard/cam/cam-program-article/cam-program-article-form.interface';
import {
  CamProgramArticleFormFilesInterface
} from '../../../dashboard/cam/cam-program-article/cam-program-article-form/cam-program-article-form-images.interface';
// tslint:disable-next-line: max-line-length
import { CamProgramArticleFormModelProgramItemInterface } from '../../../dashboard/cam/cam-program-article/cam-program-article-form/cam-program-article-form-model-program-item.interface';
import { ArticleVersionBuilder } from '../../models/builders/article-version.builder';

const getUpdateFiles = (file: CamProgramArticleFormFilesInterface[]) => {
  return (isArray(file))
    ? file.map(image => ({
      hash: image.hash ? image.hash : null,
    }))
    : [];
};

const getUpdateCamProgramArticleFormModelProgramBody = (modelsPrograms: CamProgramArticleFormModelProgramItemInterface[]) => {
  return (isArray(modelsPrograms))
    ? modelsPrograms.map(modelProgram => ({
      modelHash: modelProgram.modelHash,
      programReference: modelProgram.programReference,
    }))
    : [];
};

const getCreatedCamBody = (cam: CamProgramArticleFormInterface) => {
  const postBody = new FormData();
  postBody.append('articleHash', cam.articleHash);
  postBody.append('operationHash', cam.operationHash);
  postBody.append('modelsPrograms', JSON.stringify(getUpdateCamProgramArticleFormModelProgramBody(cam.modelsPrograms)));
  if (!!cam.information) {
    postBody.append('information', cam.information);
  }
  if (!!cam.newImages) {
    for (let i = 0; i < cam.newImages.length; i++) {
      postBody.append('images', cam.newImages[i]);
    }
  }

  if (!!cam.newPDFs) {
    for (let i = 0; i < cam.newPDFs.length; i++) {
      postBody.append('pdfs', cam.newPDFs[i]);
    }
  }
  return postBody;
};

const getUpdatedCamBody = (cam: CamProgramArticleFormInterface) => {
  const postBody = new FormData();
  postBody.append('articleHash', cam.articleHash);
  postBody.append('operationHash', cam.operationHash);
  postBody.append('modelsPrograms', JSON.stringify(getUpdateCamProgramArticleFormModelProgramBody(cam.modelsPrograms)));

  if (cam.images) {
    postBody.append('images', JSON.stringify(getUpdateFiles(cam.images)));
  }
  if (cam.pdfs) {
    postBody.append('pdfs', JSON.stringify(getUpdateFiles(cam.pdfs)));
  }
  if (!!cam.information) {
    postBody.append('information', cam.information);
  }
  if (cam.newImages) {
    for (let i = 0; i < cam.newImages.length; i++) {
      postBody.append('newImages', cam.newImages[i]);
    }
  }

  if (cam.newPDFs) {
    for (let i = 0; i < cam.newPDFs.length; i++) {
      postBody.append('newPDFs', cam.newPDFs[i]);
    }
  }

  return postBody;
};

@Injectable()
export class ArticleCamApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${environment.apiUrl}articles-cams`;
  }

  createCam(cam: CamProgramArticleFormInterface) {
    return this.httpClient.post(`${this.apiUrl}`, getCreatedCamBody(cam))
      .pipe(
        map(ArticleVersionBuilder.fromJson)
      );
  }

  updateCam(cam: CamProgramArticleFormInterface) {
    return this.httpClient.post(`${this.apiUrl}/${cam.camHash}`, getUpdatedCamBody(cam))
    .pipe(
      map(ArticleVersionBuilder.fromJson)
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/article-cam-api.service.ts